import { useQuery } from '@tanstack/react-query';

import { sessionService } from '../../application/SessionService';

type UseSessionLoginCodeResponseProps = {
  isLogged?: boolean;
  isLoading: boolean;
};

export const useIsLogged = (): UseSessionLoginCodeResponseProps => {
  const { data, isLoading } = useQuery([`user_is_logged`], () => sessionService.isLogged());

  return {
    isLogged: data,
    isLoading,
  };
};
